import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import StockLocationForm from '../stock_location_form/StockLocationForm';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { EditPage } from '../edit_page/EditPage';
import { canFieldManageStockLocation } from '../common/FeildTechSLManagePermissionChecker';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const style = require('./EditStockLocationPage.less');

class EditStockLocationPage extends React.Component<any, any> {
	componentDidMount() {
		const { getStockLocation, match } = this.props;
		const id = match.params.id;
		getStockLocation(id);
	}

	render() {
		const { history, stockLocation, fetching, match, currentUser, companyConfig } = this.props;
		const id = match.params.id;

		const isTargetStockLocationLoaded = `${nullSafeGet('id', stockLocation)}` === `${id}`;
		if (
			isTargetStockLocationLoaded &&
			!canFieldManageStockLocation(currentUser, stockLocation, companyConfig)
		) {
			return <Redirect to={`/supplier/stockLocations/detail/${id}`} />;
		}

		return [
			<EditPage
				title="Edit Stock Location"
				formComponentProps={{
					formData: stockLocation,
					onSuccess: (rec) => history.push(`/supplier/stockLocations/detail/${rec.id}`),
				}}
				fetching={fetching}
				FormComponent={StockLocationForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		stockLocation: state.stock_locations.detail,
		fetching: state.stock_locations.fetching,
		currentUser: state.session.currentUser,
		companyConfig: state.company_config.detail,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getStockLocation: (id) => dispatch(stockLocationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditStockLocationPage));
